import { useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import { SupplierEnrollScreen } from '@/routes/admin/suppliers/supplier-enroll-screen';

// =============================================================================
// supplier-enroll-route.tsx — Adaptateur routeur de l'écran A-05.
// =============================================================================
// « /admin/suppliers/new ». Le SIRET enrôlé est saisi DANS l'écran (acte 1), puis
// devient la ressource d'URL des actes suivants (ouverture de fiche A-04). Le
// composant de présentation reste testable hors routeur.

export function SupplierEnrollRoute(): React.JSX.Element {
  const navigate = useNavigate();

  const onDone = React.useCallback((): void => {
    void navigate({ to: '/admin/suppliers' });
  }, [navigate]);

  const onOpenDetail = React.useCallback(
    (siret: string): void => {
      void navigate({ to: '/admin/suppliers/$siret', params: { siret } });
    },
    [navigate],
  );

  return <SupplierEnrollScreen onDone={onDone} onOpenDetail={onOpenDetail} />;
}
